import Icon from '../components/Icon.vue'

Icon.register({
  'toggle-off': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M384 64H192C86 64 0 150 0 256S86 448 192 448H384C490 448 576 362 576 256S490 64 384 64zM64 256C64 185.3 121.2 128 192 128 262.7 128 320 185.2 320 256 320 326.7 262.8 384 192 384 121.3 384 64 326.8 64 256zM384 384H335.1C400.3 311.1 400.3 200.9 335.1 128H384C454.7 128 512 185.2 512 256 512 326.7 454.8 384 384 384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/toggle-off.js
// module id = fPSx
// module chunks = 144